module.exports = __webpack_public_path__ + "static/media/cunningham.b492dd41.png";